import { Editor } from "@appquality/appquality-design-system";
import { useState } from "react";
import { styled } from "styled-components";

const StyledEditor = styled(Editor)`
  border: 1px solid ${(props) => props.theme.colors.gray100};
`;

export const MarkdownEditor = ({
  onChange,
  initialValue,
  placeholder,
}: {
  onChange: (value: string) => void;
  initialValue: string;
  placeholder?: string;
}) => {
  const [value, setValue] = useState(initialValue);

  return (
    <StyledEditor
      onUpdate={({ editor }: { editor: any }) => {
        setValue(editor.getMarkdown());
      }}
      onBlur={() => onChange(value)}
      disableHeader
      disableSaveShortcut
      hasInlineMenu
      contentType="markdown"
      placeholderOptions={{
        placeholder: placeholder || "",
      }}
    >
      {value}
    </StyledEditor>
  );
};
